import parse, {
  domToReact,
  type DOMNode,
  type HTMLReactParserOptions,
} from "html-react-parser";
import { Fragment, type ReactNode } from "react";

import { parseStyleString } from "./parse-style-string";
import { processText } from "./process-text";

/**
 * sanitize 된 HTML 문자열을 React 노드로 파싱한다.
 *  - text 노드: React 엘리먼트 자리표시자 복원(processText)
 *  - span: 인라인 style 적용
 *  - br: 줄바꿈
 */
export const renderHtmlWithReactComponents = (
  htmlString: string,
  components: Record<string, ReactNode>
): ReactNode => {
  const options: HTMLReactParserOptions = {
    replace: domNode => {
      if (domNode.type === "text" && domNode.data) {
        return <>{processText(domNode.data, components)}</>;
      }

      if (
        domNode.type === "tag" &&
        domNode.name === "span" &&
        domNode.children.length
      ) {
        return (
          <span style={parseStyleString(domNode.attribs.style ?? "")}>
            {Array.from(domNode.children).map((child, index) => {
              if (child.type === "text" && child.data) {
                return (
                  <Fragment key={`txt-${index}`}>
                    {processText(child.data, components)}
                  </Fragment>
                );
              }
              return (
                <Fragment key={`dom-${index}`}>
                  {domToReact([child] as DOMNode[], options)}
                </Fragment>
              );
            })}
          </span>
        );
      }

      if (domNode.type === "tag" && domNode.name === "br") {
        return <br />;
      }

      return undefined;
    },
  };

  return parse(htmlString, options);
};
